/**
 * @file
 *
 * This file exists purely because we needed to apply a transformation to the modal
 * after rendering in Safari to work around this webkit bug: https://bugs.webkit.org/show_bug.cgi?id=176896
 */
(function (angular) {
  "use strict";

  angular.module("app").service("modalService", modalService);

  modalService.$inject = ["$uibModal"];

  function modalService($uibModal) {
    function open(params) {
      var modal = $uibModal.open(params);
      modal.rendered.then(function () {
        var dialogs = document.getElementsByClassName("modal-dialog");
        var el = dialogs[0] as HTMLElement;
        el.style.transform = "translate(0, 1px)";
      });
      return modal;
    }

    return {
      open: open,
    };
  }
})(angular);
